export const hlENz = {
  home: {
    title1: 'Awesome title1',
    title2: 'Awesome title2'
  },
  cmn: {
    activity: 'activity',
    active: 'active',
    all: 'all',
    color: 'color',
    deriverable: 'deriverable',
    done: 'done',
    finished: 'finished',
    hold: 'hold',
    in_progress: 'in progress',
    new: 'new',
    order: 'order',
    pending: 'pending',
    process: 'process',
    project: 'project',
    task: 'task',
    tag: 'tag',
    team: 'team',
    to_do: 'to do',
    wait: 'wait',
    zzz: 'zzz',
    language: {
      fml: 'language',
    },
    fontSize: {
      fml: 'font size',
    },
    clrMode: {
      fml: 'colour mode',
    },
  },
  i01r: {
    i01r_0001s: {
      fml: 'project id',
      aan: 'id'
    },
    i01r_0002s: {
      fml: 'project name',
      aan: 'name'
    },
    i01r_05r0k: {
      fml: 'client',
      aan: 'client'
    },
    i01r_05r0k_1: {
      fml: 'partner A',
      aan: 'partner A'
    },
    i01ri01t0k: {
      fml: 'type',
      aan: 'type'
    },
    i01ri01t0k_10: {
      fml: 'development',
      aan: 'development'
    },
    i01ri01t0k_20: {
      fml: 'maintenance',
      aan: 'maintenance'
    },
    i01ri01t0k_30: {
      fml: 'SES',
      aan: 'SES'
    },
    i01ri01s0k: {
      fml: 'status',
      aan: 'status'
    },
    i01ri01s0k_10: {
      fml: 'before inquiry',
      aan: 'before inquiry'
    },
    i01ri01s0k_20: {
      fml: 'inquiry',
      aan: 'inquiry'
    },
    i01ri01s0k_30: {
      fml: 'order received',
      aan: 'inquiry'
    },
    i01ri01s0k_40: {
      fml: 'delivered',
      aan: 'delivered'
    },
    i01ri01s0k_50: {
      fml: 'accepted',
      aan: 'accepted'
    },
    i01ri01s0k_60: {
      fml: 'billed',
      aan: 'billed'
    },
    i01ri01s0k_90: {
      fml: 'completed',
      aan: 'completed'
    }
  }
}
